import { createSlice } from "@reduxjs/toolkit";

const formSlice = createSlice({
  name: "customForms",
  initialState: {
    newAccount: [],
    newUser: [],
    formCache: {},
    selectedCountry: "", // Add selectedCountry to the state
  },

  reducers: {
    setNewAccountForm: (state, action) => {
      state.newAccount = action.payload.newAccount;
    },
    setNewUserForm: (state, action) => {
      state.newUser = action.payload.newUser;
    },
    setFormData: (state, action) => {
      const { formName, data } = action.payload;
      // console.log(formName, data);
      state.formCache[formName] = data;
    },
    setSelectedCountry: (state, action) => {
      state.selectedCountry = action.payload; // Update selectedCountry
    },
  },
});

export const { setNewAccountForm, setNewUserForm, setFormData, setSelectedCountry } =
  formSlice.actions;

export default formSlice.reducer;
